import { render, staticRenderFns } from "./LoadashLicenseView.vue?vue&type=template&id=2ed15057"
import script from "./LoadashLicenseView.vue?vue&type=script&lang=js"
export * from "./LoadashLicenseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports